/**
 * WOM Configuration for Vessels Client
 *
 * Client-specific configuration including:
 * - API endpoints
 * - Theme colors and styling
 * - Enabled widgets
 * - Custom behavior
 */

const vesselsWOMConfig = {
  name: "Varnika Replicate",

  // API Configuration – staging
  apiBaseUrl: "https://api.thewordofmouth.in",
  companyId: "vaarnika",

  // Product reviews: GET https://staging.thewordofmouth.in/api/reviews/varnika/{product-handle}
  // Builds from apiBaseUrl + companyId + product handle (no reviewsApiUrl getter needed).

  // Collection/overall ratings: GET https://staging.thewordofmouth.in/api/varnika/
  collectionApiUrl: "https://api.thewordofmouth.in/api/vaarnika/",

  // Legacy overall_company (same data as collectionApiUrl if API supports it)
  overallCompanyApiUrl: "https://api.thewordofmouth.in/api/overall_company/vaarnika",

  // Brand-wide reviews
  brandReviewsApiUrl: "https://api.thewordofmouth.in/api/brand-reviews/vaarnika",

  // Instagram API URL
  instagramApiUrl: "https://api.thewordofmouth.in/api/instagram-images/vaarnika",

  // Video API URL
  videoApiUrl: "https://api.thewordofmouth.in/api/video/videos/vaarnika",

  // Use local JSON data instead of API (set to false to use API)
  useLocalData: false, // Using live API
  localDataUrl: "/assets/wom-product-data.json", // Path to local JSON file

  // Debug mode
  debug: true,

  // Theme Colors - Override default colors (can customize for vaarnika brand)
  colors: {
    primary: "#1a1a1a",
    accent: "#3b82f6",
    background: "#ffffff",
    text: "#374151",
    textLight: "#6b7280",
    border: "#e5e7eb",
    success: "#10b981",
    starColor: "#FF8C00",
  },

  // Typography
  fontFamily:
    "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

  // Spacing and Layout
  spacing: {
    cardRadius: "12px",
    cardPadding: "20px",
    gap: "16px",
  },

  // Widget Configuration - Enable/Disable widgets
  components: {
    socialProof: true, // Shows "X reviews in last month"
    liveUsers: true, // Shows "X people viewing now"
    ratingBreakdown: true, // Shows star rating distribution
    reviews: true, // Shows full review cards
  },

  // Override to use company-wide data instead of product-specific
  useCompanyWideData: false, // Using product-specific API that works without auth

  // Widget Settings
  settings: {
    liveUpdates: true, // Auto-refresh live data
    showVerifiedBadge: true, // Show verified purchase badges
    reviewsPerPage: 4, // Number of reviews to show initially
  },

  // Custom Callbacks (Optional)
  onWriteReview: function () {
    // Custom logic when "Write Review" is clicked
    console.log("Opening write review modal");
    // Add your custom modal logic here
  },

  onLoadMore: function () {
    // Custom logic when "Load More" is clicked
    console.log("Loading more reviews");
    // Add your custom pagination logic here
  },
};

// Export for use
if (typeof module !== "undefined" && module.exports) {
  module.exports = vesselsWOMConfig;
} else {
  // Expose to window with both names for backward compatibility
  window.vesselsWOMConfig = vesselsWOMConfig; // Primary
  window.clientWOMConfig = vesselsWOMConfig; // Alias for backward compatibility
}
